import { CreateTransactionCreditPayload } from "@/models/payload/wallet";
import clubRequest from "../axios";

const getWalletBalance = async () =>
  (await clubRequest.balanceList()).data;

const increaseWalletBalance = async (command: CreateTransactionCreditPayload) =>
  (await clubRequest.transactionCreditCreate(command)).data;

const walletService = {
  getWalletBalance,
  increaseWalletBalance,
};

export default walletService;
